// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"594":"71a5fb30","953":"8f61d802"}[chunkId] + ".js";
};